import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const Faq = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div className="pb-5">
                    <h1 className="title-partslist-page">よくあるご質問</h1>
                    <div className="img-three-dot">
                        <img src="images/three-dot.png" className="img-fluid"/>
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>購入後、確認のメール等が来ないのですが、なぜでしょうか？</span>
                    </h2>
                    <div className="description-item-parts">
                        注文確認メールなどの自動配信メールに関しましては、注文が確定した段階でサシイレからお送りしているメールとなります。ご利用のプロバイダでサシイレのメールが迷惑メールアドレスとして認識され、迷惑メールフォルダに入ることや、「遅配」や「不配」などが発生することもあるようでございます。<br/>
                        ご利用のプロバイダの詳細につきましては、サシイレにて分かりかねますので、いま一度メール設定をご確認いただき、不明点がある場合にはご利用いただいておりますプロバイダまで直接お問い合わせいただきますようお願いいたします。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>配送日時を指定出来ますか？</span>
                    </h2>
                    <div className="description-item-parts">
                        明確な日時の指定は現段階では出来かねます。配送に関する情報は<Link to="/delivery">こちら</Link>をご覧下さい。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>決済方法は何がありますか？</span>
                    </h2>
                    <div className="description-item-parts">
                        クレジットカード、銀行振込をご利用頂くことが出来ます。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>掲載されていない部活にもサシイレをしたいのですが。</span>
                    </h2>
                    <div className="description-item-parts">
                        有り難うございます。大変申し訳ございませんが、現在サシイレが可能な部活は弊サイト掲載部活のみになっております。今後、大学スポーツの発展のために、順次サシイレ可能部活は増やしていく予定ですが、サシイレご希望の部活などありましたら是非<Link to="/contact">こちら</Link>からご連絡下さい。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>ここに載っていない商品もサシイレしたいのですが。</span>
                    </h2>
                    <div className="description-item-parts">
                        有り難うございます。大変申し訳ございませんが、現在サシイレが可能な商品は弊サイト掲載商品のみになっております。今後、大学スポーツの発展のために、順次サシイレ可能商品は増やしていく予定ですが、サシイレご希望の商品などありましたら是非<Link to="/contact">こちら</Link>からご連絡下さい。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>部活からの御礼として貰えるものはどういったものでしょうか？</span>
                    </h2>
                    <div className="description-item-parts">
                        サシイレをした部活から、御礼のメッセージが届きます。またご希望のお客様にはポストカードの配送も行っております。このポストカードには選手達の写真とメッセージが付いてきます。また部活によってはチケット等のプレゼントもあるかもしれません。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>部活がサシイレを望んでいない商品を送ってしまわないか不安なのですが？</span>
                    </h2>
                    <div className="description-item-parts">
                        部活ごとに、その部活がサシイレして欲しい商品が表示されているのでその心配はございません。
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default Faq